import { Injectable } from '@angular/core';
import { UrlTree, Router } from '@angular/router';

import { Observable } from 'rxjs';

import { SessionService } from '../services/session.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private router: Router, private sessionService: SessionService) { }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if (!this.sessionService.isLoggedIn()) {
      return true;
    } else {
      return this.router.createUrlTree(['/dashboard']);
    }
  }

}
